import { themeColors } from '../theme/theme';
import { PARCEL_STATUS } from './parcelEnums';

/**
 * Status styles for parcels - consistent across all components
 * Uses theme colors for consistency
 */
export const STATUS_STYLES = {
  [PARCEL_STATUS.PENDING]: {
    color: themeColors.pendingColor || '#92400e',
    bg: themeColors.pendingBg || '#fef3c7',
  },
  [PARCEL_STATUS.ASSIGNED]: {
    color: themeColors.assignedColor || '#1d4ed8',
    bg: themeColors.assignedBg || '#dbeafe',
  },
  PICKED_UP: {
    color: '#6d28d9',
    bg: '#ede9fe',
  },
  [PARCEL_STATUS.IN_TRANSIT]: {
    color: themeColors.inTransitColor || '#4338ca',
    bg: themeColors.inTransitBg || '#e0e7ff',
  },
  OUT_FOR_DELIVERY: {
    color: '#0e7490',
    bg: '#cffafe',
  },
  [PARCEL_STATUS.DELIVERED]: {
    color: themeColors.deliveredColor || '#15803d',
    bg: themeColors.deliveredBg || '#dcfce7',
  },
  [PARCEL_STATUS.COMPLETED]: {
    color: themeColors.completedColor || '#15803d',
    bg: themeColors.completedBg || '#dcfce7',
  },
  [PARCEL_STATUS.CANCELLED]: {
    color: themeColors.cancelledColor || '#b91c1c',
    bg: themeColors.cancelledBg || '#fee2e2',
  },
  [PARCEL_STATUS.RETURNED]: {
    color: themeColors.returnedColor || '#9333ea',
    bg: themeColors.returnedBg || '#f3e8ff',
  },
  [PARCEL_STATUS.FAILED]: {
    color: themeColors.failedColor || '#dc2626',
    bg: themeColors.failedBg || '#fee2e2',
  },
  // Payment statuses
  PAID: {
    color: '#15803d',
    bg: '#dcfce7',
  },
  UNPAID: {
    color: '#d97706',
    bg: '#fef3c7',
  },
  default: {
    color: themeColors.primaryColor || '#6366f1',
    bg: '#f3f4f6',
  },
};

/**
 * Get status style by status string (case-insensitive)
 * @param {string} status - Status string
 * @returns {object} { color, bg }
 */
export function getStatusStyle(status) {
  if (!status) return STATUS_STYLES.default;
  const key = status.toUpperCase().replace(/\s+/g, '_');
  return STATUS_STYLES[key] || STATUS_STYLES.default;
}

/**
 * Get status color for gradient/solid backgrounds
 * @param {string} status - Status string
 * @returns {string} Color hex value
 */
export function getStatusColor(status) {
  const statusLower = (status || '').toLowerCase();
  if (statusLower.includes('transit')) return '#2196f3';
  if (statusLower.includes('cancelled')) return '#f44336';
  if (statusLower.includes('delivered') || statusLower.includes('completed')) return '#4caf50';
  if (statusLower.includes('pending')) return '#ff9800';
  if (statusLower.includes('assigned')) return '#9c27b0';
  if (statusLower.includes('picked')) return '#673ab7';
  if (statusLower.includes('out for delivery')) return '#ff5722';
  return themeColors.primaryColor || '#667eea';
}
